import * as React from "react";
import { FC, useCallback, useEffect } from "react";
import { ImageArcGISRest } from "ol/source";
import { Image as ImageLayer } from "ol/layer";
import { PopupBody, PopupHeader, Popup } from "./Popup";
import { useNomaContext } from "../Contexts/MapContext";
import { Checkbox } from "../Elements/Checkbox";
import { config } from "../Map/config";
import { getMap } from "../Providers/mapProvider";
import { CloseButton } from "../Elements/CloseButton";
import "./LayersMenu.scss";

export const LayersMenu: FC = () => {
    const { isMobile, enabledLayers, setEnabledLayers, toggleLayersMenuVisible } = useNomaContext();

    const toggleLayer = useCallback(
        (visible: boolean, layerId: string): void => {
            const map = getMap();
            const layerConfig = config.layers.find((config) => config.id === layerId);

            if (!visible) {
                map.removeLayer(
                    map
                        .getLayers()
                        .getArray()
                        .find((layer) => layer.get("id") === layerConfig.id)
                );
                const cleanBeforeAdd = enabledLayers.filter((id) => id !== layerId);
                setEnabledLayers([...cleanBeforeAdd]);
                return;
            }

            const alreadyAdded = map
                .getLayers()
                .getArray()
                .find((layer) => layer.get("id") === layerId);

            !alreadyAdded &&
                map.addLayer(
                    new ImageLayer({
                        properties: { id: layerConfig.id },
                        source: new ImageArcGISRest({
                            url: layerConfig.url,
                            crossOrigin: layerConfig.crossOrigin,
                            attributions: layerConfig.copyright
                        })
                    })
                );
            const cleanBeforeAdd = enabledLayers.filter((id) => id !== layerId);
            setEnabledLayers([...cleanBeforeAdd, layerId]);
        },
        [enabledLayers]
    );

    useEffect(() => {
        enabledLayers.map((layerId) => toggleLayer(true, layerId));
    }, []);

    return (
        <Popup id={"layers-popup"} isMobile={isMobile} hasBackdrop={false} notDraggable={true}>
            {isMobile ? (
                <PopupHeader isMobile={isMobile}>
                    <CloseButton onClose={toggleLayersMenuVisible}></CloseButton>
                </PopupHeader>
            ) : (
                <div className="triangle-left"></div>
            )}
            <PopupBody isMobile={isMobile}>
                {config.layers.map((layer) => {
                    return (
                        <div key={"layer-" + layer.id}>
                            <Checkbox
                                label={layer.title}
                                subTitle={"© " + layer.copyright}
                                checked={enabledLayers.includes(layer.id)}
                                onChange={(e) => toggleLayer(e, layer.id)}
                            ></Checkbox>
                        </div>
                    );
                })}
            </PopupBody>
        </Popup>
    );
};
